import { BudgetLineDto } from 'api/budgets/models/BudgetDto';
import { BudgetLineParameterDto } from 'api/budgets/models/BudgetLineParameterDto';
import { ParameterSectionParameterType, ParameterSectionType } from 'common/components/parametersSections/models';
import ParametersList from './parametersList/ParametersList';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
// import { useSelector } from 'react-redux';
// import { Reducers } from 'store/types';
// import LoadingSpinner from 'common/components/loading/LoadingSpinner';

interface Props {
    line: BudgetLineDto;
    disabled: boolean;
    highlightParameterKeys?: string[];
}

const filterProductParameters = (parameters: BudgetLineParameterDto[] | null | undefined): BudgetLineParameterDto[] => {
    if (!parameters) return [];
    return parameters
        .filter(p => p.type !== ParameterSectionType.PARAMETER || p.parameterType !== ParameterSectionParameterType.PRODUCTS)
        .map(p => ({
            ...p,
            children: filterProductParameters(p.children),
        }))
        .filter(p => p.type !== ParameterSectionType.SECTION || p.children.length > 0);
};

function ConfigureTab({ line, disabled, highlightParameterKeys }: Props): JSX.Element | null {
    const { t } = useTranslation();
    // const calculating = useSelector((state: Reducers) => state.budget.calculating);

    const parameters = useMemo(() => {
        return filterProductParameters(line.parameters);
    }, [line.parameters]);

    return (
        <div>
            {/* {calculating && (
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10,
                    pointerEvents: 'all',
                }}>
                    <LoadingSpinner size={30} />
                </div>
            )} */}
            {parameters.length > 0 && (
                <ParametersList
                    parameters={parameters}
                    level={0}
                    line={line}
                    disabled={disabled}
                    highlightParameterKeys={highlightParameterKeys}
                />
            )}
            {parameters.length === 0 && (
                <div>
                    {t('messages.no_info_to_show')}
                </div>
            )}
        </div>
    );
}

export default ConfigureTab;
